<template>
  <div class="cardlist">
    <div class="cardlist-title">
      
    </div>
    <div class="dropdownaction_icon">
      <span class="cancelblock" v-if="clearSelected && selected && selected.length !== 0" @click="updateMethod([],$event);">
        <svgicon name="cancelblack" width="8" height="8" :original="true" />
      </span>
      <span class="cancelblock" v-else>
        <svgicon name="fill_arrow" width="8" height="8" :original="true" />
      </span>
    </div>
    <div class="cardlist-dropdown spacing">
      <Multiselect :value="selected" :options="list" :multiple="true" 
      :close-on-select="false" :clear-on-select="false" :preserve-search="true" 
      :placeholder="placeholder" :label="label" :track-by="label" :preselect-first="false"
      @input="updateMethod">
        <template slot="selection" slot-scope="{ values, search, isOpen }">
          <span class="multiselect__single" v-if="values.length === 1 &amp;&amp; !isOpen">    
            <Ellipsis 
                    :text="values[0].name || values[0].description"
                    length="15" />
            </span>
          <span class="multiselect__single" v-else-if="values.length &amp;&amp; !isOpen">    
            {{ values.length }} options selected</span>
        <div class="dropdownaction_icon">
          <span class="arrowblock">
            <svgicon v-if="values.length === 0" name="fill_arrow" width="9" height="9" :original="true" />
          </span>
          <div class="dropdownaction_icon">
            <span class="arrowblock">
              <svgicon v-if="values.length === 0" name="fill_arrow" width="9" height="9" :original="true" />
            </span>
          </div>
        </div>
        </template>
      </Multiselect>
	  </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
    category: "",
    placeholder: "",
    maxSelectionAllowed: {
      type: Number,
      required: false,
    },
    clearSelected: {
      type: Boolean,
      default: false,
    },
    selectAllOption: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'name'
    }
  },
  data () {
    return {
      value: [],
      list: [],
      selectedAll: false,
      selectAll: { 
        id: 0, 
        name: "Select All" 
      },
    }
  },
  created() {
    this.list = this.options.map(val => Object.assign(val, { $isDisabled : false }));
    if (this.selectAllOption && !this.maxSelectionAllowed) {
      this.list.unshift(this.selectAll);
    }
  },
  methods: {
    updateMethod(values,event= null) {
      if(this.maxSelectionAllowed) {
        if(values.length === this.maxSelectionAllowed) {
          this.list = this.list.map(val => {
            if(!values.includes(val)) {
              return Object.assign(val, { $isDisabled : true });
            } else {
              return val;
            }
          });
        } else {
          //clearing all the disabled items
          this.list = this.options.map(val => Object.assign(val, { $isDisabled : false }));
        }
      } else if (values.includes(this.selectAll)) {
        values = this.list;
        this.selectedAll = true;
      } else if (this.selectedAll) {
        values = [];
        this.selectedAll = false;
      }
      this.$emit('updateOption',values);
      if(event) {
        event.stopPropagation();
      }
    },
  },
}

</script>
